export interface Location {
  name: string;
  address: string;
  city: string;
  phone: string;
  mapUrl: string;
}

export default [
  {
    name: 'Michigan City',
    address: '1612 Franklin Street',
    city: 'Michigan City, IN',
    phone: '(219) 872-0571',
    mapUrl: 'https://www.google.com/maps/place/Albano%27s+Villa/@41.7073573,-86.8964382,17z',
  },
  {
    name: 'La Porte',
    address: '401 J Street',
    city: 'La Porte, IN',
    phone: '(219) 325-3331',
    mapUrl: 'https://www.google.com/maps/place/Albano%27s+Villa/@41.6036508,-86.7298887,17z',
  },
  {
    name: 'Johnson Road',
    address: '6492 Johnson Road',
    city: 'La Porte, IN',
    phone: '(219) 879-4000',
    mapUrl: 'https://www.google.com/maps/place/Albano%27s+Pizza+Inc/@41.659765,-86.8255303,17z',
  },
] satisfies Location[];
